export default __webpack_public_path__ + "static/media/petit.23bab41f.png";